export const DynamicFormTypesEnum = {
    array: {
        key: 'array',
    },
    select: {
        key: 'select',
    },
    number: {
        key: 'number',
    },
    text: {
        key: 'text',
    },
    uploader: {
        key: 'uploader',
    },
};
